import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import iconCalendar from '@root/gatsby-contentful-core/src/assets/icons/calendar.svg';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { toRgba } from '@root/gatsby-contentful-core/src/utils/colors';

export default function DateDropdownButton({ handleDateDropdown }) {
  return (
    <button
      css={styles.datePickerButton}
      onClick={handleDateDropdown}
    >
      <span css={styles.datePickerButtonText}>Date range</span>
      <img
        alt={'calendar icon'}
        css={styles.datePickerButtonIcon}
        src={iconCalendar}
      />
    </button>
  );
}

DateDropdownButton.propTypes = {
  handleDateDropdown: PropTypes.func,
};

const zEase = 'cubic-bezier(0.165, 0.84, 0.44, 1)';

const styles = StyleSheet.create({
  datePickerButton: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
    padding: '10px 12px',
    appearance: 'none',
    backgroundColor: Colors.white(),
    border: 'none',
    borderRadius: 6,
    boxShadow: `0 0 0 1px ${Colors.gray40()}`,
    color: Colors.gray60(),
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '100%',
    transition: `300ms ${zEase}`,
    '&:focus': {
      outline: 'none',
      boxShadow: `0 0 0 1px ${Colors.rootOrange()}, 0 0 0 7px ${toRgba(Colors.rootOrange(), 0.25)}`,
    },
    '&:focus:not(.focus-visible)': {
      boxShadow: `0 0 0 1px ${Colors.rootOrange()}`,
    },
    ...Responsive.md({
      padding: '10px 18px',
    }),
  },
  datePickerButtonText: {
    display: 'none',
    ...Responsive.md({
      marginRight: 10,
      display: 'block',
    }),
  },
  datePickerButtonIcon: {
    width: 22,
    ...Responsive.md({
      width: 18,
    }),
  },
});
